<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addClassHourDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <!--自定义条目-->
        <el-form-item prop="type" label="自定义条目">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入自定义条目内容"
            v-model="form.type"
          ></el-input>
        </el-form-item>
        <!--课时类型-->
        <!-- <el-form-item required prop="coursePackageId" label="课包类型"> -->
        <!-- <el-cascader
            v-model="form.coursePackageId"
            :options="options"
            collapse-tags
            :show-all-levels="false"
            @change="changeVal"
            clearable
          ></el-cascader> -->
        <!-- <el-select
            v-model="form.coursePackageId"
            placeholder="请选择课包类型"
          >
            <el-option
              v-for="item in this.coursePackageList.coursePackageList"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select> -->
        <!-- </el-form-item> -->
        <!--课时增加/减少-->
        <el-form-item prop="courseHours" label="课时增加/减少">
          <el-input
            type="text"
            placeholder="类似+1/-1"
            v-model="form.courseHours"
          ></el-input>
        </el-form-item>
        <el-form-item prop="activeName" label="活动名称">
          <el-input
            type="text"
            placeholder="请输入活动名称"
            v-model="form.activeName"
          ></el-input>
        </el-form-item>
        <el-form-item required label="会员课包" >
          <el-select
            v-model="form.coursePackageAndMemberId"
            placeholder="请选择"
            style="width:100%"
            @change="getOptionDataAndRender"
          >
            <el-option
              v-for="item in this.coursePackageAndMemberOption"
              :key="item.id"
              :label="item.coursePackageName + ' ' +  '（ 购买日期:' + (item.buyTime ? item.buyTime : '暂无日期')  + ' ' + '剩余课时数:' + item.classHour + ' )' "
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item required prop="buyDate" label="课包购买日期">
          <el-date-picker
            v-model="form.buyDate"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item prop="notes" label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入事件内容"
            v-model="form.notes"
          ></el-input>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addClassHourSpend } from "@/api/classhourspend";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";
import { getCoursePackageAndMemberByCoursePackageId } from "@/api/memberCoursePackage";

export default {
  name: "addFundDialogs",
  data() {
    let validateClassHour = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("课时增加/减少不能为空"));
      } else {
        var reg = /^\+|-/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的格式(+1|-1)"));
        } else {
          callback();
        }
      }
    };
    return {
      props: { emitPath: false },
      options: [],
      isVisible: this.isShow,
      coursePackageAndMemberOption: [
        {
          id: "-1",
          coursePackageName: "该会员没有这种类型的课包",
          buyTime: "暂无日期",
          classHour: "暂无课时数",
        }
      ],
      form: {
        id: "",
        username: "",
        type: "",
        id: "",
        activeName: "",
        courseHours: "",
        opreateDate: "",
        notes: "",
        buyDate: "",
        coursePackageAndMemberId: "-1",
      },
      classHourType: [
        { label: "通用课时", value: "0" },
        { label: "启蒙课时", value: "1" },
      ],
      form_rules: {
        type: [
          { required: true, message: "自定义条目不能为空", trigger: "blur" },
        ],
        classhourType: [
          { required: true, message: "课时类型不能为空", trigger: "blur" },
        ],
        courseHours: [
          { required: true, message: "课时增加/减少不能为空", trigger: "blur" },
          { validator: validateClassHour },
        ],
        opreateDate: [
          { required: true, message: "日期不能为空", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    username: String,
    coursePackageList: Object,
    name: Object,
  },
  computed: {
    ...mapGetters(["addClassHourDialog"]),
  },
  created() {},
  mounted() {
    // console.log(this.coursePackageList);
    // console.log(this.username);
    this.getFormatCoursePackagesForCourse();
    this.changeVal();
    if (this.addClassHourDialog.type === "edit") {
      console.log(this.dialogRow);
      this.form = this.dialogRow;
      this.form.eventType = this.dialogRow.eventType.toString();
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    changeVal() {
      // const coursePackageId = val[1];
      // console.log(coursePackageId);
      getCoursePackageAndMemberByCoursePackageId({
        // coursePackageId: coursePackageId,
        username: this.username,
      }).then((res) => {
        if (res.data.code === 200) {
          this.form.coursePackageAndMemberId = "";
          this.coursePackageAndMemberOption = res.data.data.coursePackageAndMemberDatas;
        } else {
          this.form.coursePackageAndMemberId = "-1";
          this.coursePackageAndMemberOption = [
            {
              id: "-1",
              coursePackageName: "该会员没有这种类型的课包",
              buyTime: "暂无日期",
              classHour: "暂无课时数",
            },
          ];
        }
      });
    },
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log("getFormatCoursePackagesForCourse");
        console.log(res);
        this.options = res.data.data;
      });
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          // console.log(formData.classhourType)
          // let classhourType = formData.classhourType === "0" ? "通用课时" : "启蒙课时"
          // console.log(classhourType)
          var currentDate = new Date();
          var currentMonth = currentDate.getMonth() + 1;
          // console.log(currentMonth)
          var opreateDate =
            currentDate.getFullYear() +
            "-" +
            currentMonth +
            "-" +
            currentDate.getDate() +
            " " +
            currentDate.getHours() +
            ":" +
            currentDate.getMinutes() +
            ":" +
            currentDate.getSeconds();
          // console.log(opreateDate)
          console.log(this.form.coursePackageAndMemberId);
          //获取当前选中的课包对象
          let courseObj = {}
          this.coursePackageAndMemberOption.forEach(item => {
            if(item.id === formData.coursePackageAndMemberId) {
              courseObj = item
              return
            }
          })
          const para = {
            id: formData.coursePackageAndMemberId,
            username: this.username,
            opreateDate: opreateDate,
            type: formData.type,
            courseHours: formData.courseHours,
            coursePlace: "",
            pointAddress: "",
            notes: formData.notes,
            coursePackageId: courseObj.coursePackageId,
            buyDate: formData.buyDate,
            coursePackageAndMemberId: formData.coursePackageAndMemberId,
            activeName: formData.activeName
          };
          console.log(para);
          // edit
          if (this.addClassHourDialog.type === "edit") {
          } else {
            // add
            addClassHourSpend(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                var type = formData.type; // 课时账单条目
                var coursehours = formData.courseHours; // 课时数
                var note = formData.notes; // 备注
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "增加会员(" +
                    this.name +
                    ")课时账单操作" +
                    "课时账单条目为:" +
                    type +
                    ",课时增减为:" +
                    coursehours +
                    ",课时备注为:" +
                    note,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getClassHourList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
    getOptionDataAndRender(e) {
      let element = this.coursePackageAndMemberOption.find(item => item.id === e)
      if(element !== undefined) {
        this.form.activeName = element.activeName
      }
    }
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
